import { combineReducers } from 'redux';
import masters from './masters';
import subscriptions from './subscriptions'
import customers from './customers'
import merchandise from './merchandise'
import movies from './movies'
import transactions from "./transactions"
import watchhours from "./watchhours"
import webseries from './webseries';
import setting from './setting'
import dashboard from './dashboard'
import layout from "./layout"
import highlight from "./highlight"
import producer from './producer'
import promotion from "./promotion"
import subtitle from "./subtitleReducer"
import complaints from "./complaints"
import competition_form from "./competitionForm"
import videosubmission from './videosubmission'
export const reducers = combineReducers({ masters,videosubmission, competition_form, complaints,  layout, dashboard, setting, subscriptions, customers,highlight, promotion, merchandise, movies,subtitle,  transactions,producer, watchhours, webseries });
